// extracted by mini-css-extract-plugin
module.exports = {"detail":"detail--fgJc0Ufne","changed":"changed--3w8fb3svx"};